import { KotlinLoggingConfiguration_getInstance1qkm2mkxywgav as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormattingAppenderClass;
function FormattingAppender() {
  if (FormattingAppenderClass === VOID) {
    class $ {
      h2f(loggingEvent) {
        // Inline function 'kotlin.let' call
        var it = KotlinLoggingConfiguration_getInstance().j2f_1.l2f().m2f(loggingEvent);
        this.g2f(loggingEvent, it);
      }
    }
    initMetadataForClass($, 'FormattingAppender');
    FormattingAppenderClass = $;
  }
  return FormattingAppenderClass;
}
//region block: exports
export {
  FormattingAppender as FormattingAppender1iqfktuucnzpr,
};
//endregion

//# sourceMappingURL=Appender.mjs.map
